// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"783":"9b16dba4","917":"776284ac"}[chunkId] + ".chunk.css";
};